import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from "@sentry/react";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ── Sentry: monitoreo de errores en producción ──────────────────────────────
// Cualquier error real de JavaScript que le pase a un cliente (en cualquier
// navegador, en cualquier momento) llega automáticamente a tu correo — antes
// de esto, esos errores quedaban solo en la consola del navegador del cliente,
// invisibles para nosotros a menos que él avisara.
Sentry.init({
  dsn: "https://60b00da27e689cf620d0d39f83930101@o4511850240540672.ingest.us.sentry.io/4511850257580032",
  // Sin esto, Sentry etiqueta TODO como "production" por defecto, incluso lo que
  // pasa mientras probás en tu compu con "npm start" — eso fue justo lo que
  // mezcló la prueba del reCAPTCHA con errores reales. Con esto, lo que pase en
  // tu compu se etiqueta "development" y solo lo del sitio ya publicado
  // (npm run build) se etiqueta "production" de verdad.
  environment: process.env.NODE_ENV,
  // Solo captura de errores — sin tracing de rendimiento ni session replay,
  // que no se activaron al crear el proyecto y no hace falta pagar su cuota.
  tracesSampleRate: 0,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* Si algo se rompe al renderizar la app (no solo en un clic suelto),
        esto evita una pantalla en blanco total y también lo reporta a Sentry. */}
    <Sentry.ErrorBoundary fallback={<div style={{padding:40,fontFamily:"sans-serif",textAlign:"center"}}>
      <h2>Algo salió mal</h2>
      <p>Ya nos llegó el aviso. Recargá la página o escribinos por WhatsApp si sigue pasando.</p>
    </div>}>
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
